import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LoginPage from "../pages/auth/login";
import RegisterPage from "../pages/auth/register";
import AuthCallbackPage from "../pages/auth/callback";
import ImpressumPage from "../pages/legal/impressum";
import DatenschutzPage from "../pages/legal/datenschutz";
import KontaktPage from "../pages/legal/kontakt";
import MemberPage from "../pages/member/page";
import SetupPage from "../pages/app/setup/page";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { lazy, Suspense } from "react";

const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const CRMPage = lazy(() => import('../pages/dashboard/crm'));
const LeadDiscoveryPage = lazy(() => import('../pages/dashboard/lead-discovery'));
const SettingsPage = lazy(() => import('../pages/dashboard/settings'));
const FunnelSettingsPage = lazy(() => import('../pages/dashboard/funnel-settings'));
const SocialMediaPage = lazy(() => import('../pages/dashboard/social-media'));
const QuizFunnelPage = lazy(() => import('../pages/funnel/quiz/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallbackPage />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
          <DashboardPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/leads",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
          <LeadDiscoveryPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/crm",
    element: (
      <ProtectedRoute>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
          <CRMPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/lead-discovery',
    element: (
      <ProtectedRoute>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
          <LeadDiscoveryPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/social-media',
    element: (
      <ProtectedRoute>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
          <SocialMediaPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/settings',
    element: (
      <ProtectedRoute>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
          <SettingsPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/funnel',
    element: (
      <ProtectedRoute>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
          <FunnelSettingsPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/funnel-settings',
    element: (
      <ProtectedRoute>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
          <FunnelSettingsPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
  {
    path: '/funnel/quiz',
    element: (
      <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
        <QuizFunnelPage />
      </Suspense>
    ),
  },
  {
    path: '/funnel/omega3-quiz',
    element: (
      <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
        <QuizFunnelPage />
      </Suspense>
    ),
  },
  {
    path: '/f/:slug',
    element: (
      <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin"></div></div>}>
        <QuizFunnelPage />
      </Suspense>
    ),
  },
  {
    path: "/member",
    element: (
      <ProtectedRoute>
        <MemberPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/app/setup",
    element: (
      <ProtectedRoute>
        <SetupPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/impressum",
    element: <ImpressumPage />,
  },
  {
    path: "/datenschutz",
    element: <DatenschutzPage />,
  },
  {
    path: "/kontakt",
    element: <KontaktPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
